module.exports = __webpack_public_path__ + "img/ico-invoice.03b2d873.svg";